import {
  FEATURED_PRODUCTS,
  RECENTLY_VIEWED
} from '@app/constants/commonConstants';
import { SPECIALS } from './constants';

/**
 * Function to determine if user is on Specials page based on the searchType
 * @param {string} searchType determines if user is in Specials Page
 * @returns true if user is in Specials page || false if user is not on Specials Page
 */
export const isSpecialsPage = searchType => searchType === SPECIALS;

/**
 * Method to display based on searchType such as specials, FeaturedParts and searchTerm
 * @param {string} searchType
 * @param {function} t
 * @param {string}  searchTerm
 * @returns translation string based on searchType and returns html elements on else condition
 */

export const getSearchBreadcrumbTitle = (searchType, t, searchTerm = '') => {
  switch (true) {
    case searchType === SPECIALS:
      return t('SPECIALS');
    case searchType === FEATURED_PRODUCTS:
      return t('CAT_FEATURED_PRODUCTS');
    case searchType === RECENTLY_VIEWED:
      return t('RECENTLY_VIEWED_TITLE_TAB');
    default:
      return searchTerm;
  }
};

/**
 * Method to display Featured Products title when search term is FeaturedParts
 * @param {string} searchType
 * @param {function} t
 * @param {string}  pageTitle
 * @returns display featured products title based on searchType
 */

export const getFeaturedProductTitle = (searchType, t, pageTitle) => {
  return searchType === FEATURED_PRODUCTS
    ? t('CAT_FEATURED_PRODUCTS')
    : pageTitle;
};
